import { FormCrud } from "components/Form/hooks"
import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { reset } from "redux-form"
import { createClassHooks } from ".."

const useSubmitBtns = () => {
    const formName = "createClass"
    const dispatch = useDispatch()
    const { actionSubmit } = FormCrud()
    const setAlert = createClassHooks.useAlert()

    const cancelAction = useCallback(() => {
        dispatch(reset(formName))
        setAlert(false)
    }, [])

    const submitBtns = [
        {
            id: 0,
            label: "ביטול",
            variant: "white",
            color: "light",
            action: () => cancelAction(formName)
        },
        {
            id: 1,
            label: "הוספה",
            variant: "regular",
            color: "secondary",
            action: () => actionSubmit(formName)
        }
    ]


    return submitBtns
}

export default useSubmitBtns